<app-page-container class="user-role-settings-container"
  [DataTableSchema]="dataTableSchema" [title]="title" [dynamicFormArray]="filterSchema" 
  [props]="props">
</app-page-container>
